import { UPDATE_WORKSPACE_LOGIN_SETTING } from './index';

export const updateWorkspaceLoginSettingAction = (workspace_login_setting) => ({
    type: UPDATE_WORKSPACE_LOGIN_SETTING,
    workspace_login_setting
});